import React, { useEffect, useState } from 'react';
import api from '../../api';
import { ActionDialog, Loading } from './ActionDialog';

const tone = { Improved: 'text-green-700 bg-green-50', Declined: 'text-red-700 bg-red-50', 'No change': 'text-gray-700 bg-gray-100' };

export const HhvbpDialog = ({ patientId, onClose }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/patients/${patientId}/hhvbp`).then(r => setD(r.data)).catch(() => setD({ measures: [] })); }, [patientId]);
  return (
    <ActionDialog title="HHVBP Legacy Measures (this patient)" onClose={onClose} testid="hhvbp-dialog" wide>
      {!d ? <Loading /> : (
        <>
          <p className="text-xs text-gray-500 mb-3">Compares the start/resumption of care OASIS with the discharge OASIS. This is an in-house estimate to spot trends, not the official CMS HHVBP score.</p>
          <table className="w-full text-sm" data-testid="hhvbp-table">
            <thead><tr className="bg-gray-50 text-left text-gray-600"><th className="p-2">Measure</th><th className="p-2">Item</th><th className="p-2">{d.startTimepoint || 'SOC'}</th><th className="p-2">Discharge</th><th className="p-2">Result</th></tr></thead>
            <tbody>{d.measures.map(m => (
              <tr key={m.item} className="border-b">
                <td className="p-2">{m.label}</td><td className="p-2 text-gray-500">{m.item}</td>
                <td className="p-2">{m.start ?? '-'}</td><td className="p-2">{m.end ?? '-'}</td>
                <td className="p-2"><span className={`px-2 py-0.5 rounded-full text-xs ${tone[m.status] || 'text-amber-700 bg-amber-50'}`}>{m.status}</span></td>
              </tr>
            ))}</tbody>
          </table>
        </>
      )}
    </ActionDialog>
  );
};
